module.exports = __webpack_public_path__ + "img/shape-9-mobile-gold@2x.06a69e94.png";